import React, { useState, useEffect } from "react";
import { ChevronUp, Mail, MapPin, Phone, LogIn } from "lucide-react";
import "../css/footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [isVisible, setIsVisible] = useState(false);

  // Efecto para la animación de aparición al cargar
  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Función para volver al inicio de la página
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };


  return (
    <footer className="oclem-footer">
      <div className="oclem-footer-content">
        {/* Sección superior con información de contacto */}
        <div className="oclem-footer-main">
          <div
            className={`oclem-footer-column oclem-footer-brand ${
              isVisible ? "oclem-footer-visible" : ""
            }`}
          >
            <h2 className="oclem-footer-title">Oclem Consultoría</h2>
            <p className="oclem-footer-description">
              Accede a la plataforma de asociados de Grupo Oclem
            </p>
            <a
              href="http://asociados.oclem.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <button className="btn-primary asociados">
                <LogIn size={16} className="oclem-footer-button-icon" />
                Acceder
              </button>
            </a>
            <div className="oclem-footer-social">
              <a href="#" className="oclem-social-icon">
                <svg
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  stroke="currentColor"
                  strokeWidth="2"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
              </a>
              <a href="#" className="oclem-social-icon">
                <svg
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  stroke="currentColor"
                  strokeWidth="2"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                  <rect x="2" y="9" width="4" height="12"></rect>
                  <circle cx="4" cy="4" r="2"></circle>
                </svg>
              </a>
              <a href="#" className="oclem-social-icon">
                <svg
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  stroke="currentColor"
                  strokeWidth="2"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
                </svg>
              </a>
            </div>
          </div>

          <div
            className={`oclem-footer-column ${
              isVisible ? "oclem-footer-visible" : ""
            }`}
          >
            <h3 className="oclem-footer-subtitle">Licitaciones</h3>
            <ul className="oclem-footer-links">
              <li>
                <a
                  href="https://www.oclem.com/gestion-licitaciones/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="oclem-footer-link"
                >
                  Licitaciones europeas
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/gestion-licitaciones/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="oclem-footer-link"
                >
                  Licita en Portugal
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/clasificacion-empresarial/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Clasificación empresarial
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/clasificacion-empresarial/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Renovación y ampliación
                </a>
              </li>
            </ul>
          </div>

          <div
            className={`oclem-footer-column ${
              isVisible ? "oclem-footer-visible" : ""
            }`}
          >
            <h3 className="oclem-footer-subtitle">Calidad</h3>
            <ul className="oclem-footer-links">
              <li>
                <a
                  href="https://www.oclem.com/calidad/normas-iso/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="oclem-footer-link"
                >
                  ISO 9001
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/calidad/normas-iso/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="oclem-footer-link"
                >
                  ISO 14001
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/calidad/normas-iso/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="oclem-footer-link"
                >
                  ISO 45001
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/calidad/normas-iso/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="oclem-footer-link"
                >
                  ISO 27001 / ENS / NIS2
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/calidad/normas-iso/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="oclem-footer-link"
                >
                  Otras ISOs
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/calidad/lopd/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LOPD
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/calidad/agenda-2030-sostenibilidad/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Agenda 2030
                </a>
              </li>
            </ul>
          </div>

          <div
            className={`oclem-footer-column ${
              isVisible ? "oclem-footer-visible" : ""
            }`}
          >
            <h3 className="oclem-footer-subtitle">Formación</h3>
            <ul className="oclem-footer-links">
              <li>
                <a
                  href="https://www.oclem.com/formacion/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Formación bonificada (FUNDAE)
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/formacion/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Desconexión digital
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/calidad/protocolo-de-acoso-laboral/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Protocolo de acoso
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/formacion/prevencion-de-riesgos-laborales/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Prevención de riesgos laborales
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/formacion/cursos-online/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Cursos online
                </a>
              </li>
            </ul>
          </div>

          <div
            className={`oclem-footer-column ${
              isVisible ? "oclem-footer-visible" : ""
            }`}
          >
            <h3 className="oclem-footer-subtitle">Jurídico</h3>
            <ul className="oclem-footer-links">
              <li>
                <a
                  href="https://www.oclem.com/juridico/derecho-mercantil-societario/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Mercantil / Societario
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/juridico/derecho-fiscal/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Fiscal
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/juridico/derecho-laboral/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Laboral
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/juridico/derecho-penal/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Penal
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/juridico/derecho-concursal/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Concursal
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/impagados/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Recobros
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/juridico/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Otros
                </a>
              </li>
            </ul>
          </div>

          <div
            className={`oclem-footer-column ${
              isVisible ? "oclem-footer-visible" : ""
            }`}
          >
            <h3 className="oclem-footer-subtitle">Gestoría</h3>
            <ul className="oclem-footer-links">
              <li>
                <a
                  href="https://www.oclem.com/gestoria/auditorias/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Auditorías
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/gestoria/gestoria-contabilidad/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Contabilidad
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/gestoria/gestoria-fiscal/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Fiscal
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/gestoria/gestoria-laboral/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Laboral
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/gestoria/gestoria-mercantil/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Mercantil
                </a>
              </li>
              <li>
                <a
                  href="https://www.oclem.com/gestoria/"
                  className="oclem-footer-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Otros
                </a>
              </li>
            </ul>
          </div>

          <div
            className={`oclem-footer-column ${
              isVisible ? "oclem-footer-visible" : ""
            }`}
          >
            <h3 className="oclem-footer-subtitle">Contáctanos</h3>
            <div className="oclem-contact-info">
              <div className="oclem-contact-item">
                <MapPin size={16} className="oclem-contact-icon" />
                <span>
                  Avenida de Madrid s/n. Zona comercial, local ZC 18-24
                </span>
              </div>
              <div className="oclem-contact-item">
                <Phone size={16} className="oclem-contact-icon" />
                <span>+34 606 440 450</span>
              </div>
              <div className="oclem-contact-item">
                <Mail size={16} className="oclem-contact-icon" />
                <span>info@oclem.com</span>
              </div>
            </div>
            {/* <div className="oclem-newsletter">
              <h4 className="oclem-newsletter-title">
                Suscríbete a nuestro boletín
              </h4>
              <div className="oclem-newsletter-form">
                <input
                  type="email"
                  placeholder="Email"
                  className="oclem-newsletter-input"
                />
                <button className="oclem-newsletter-button">Enviar</button>
              </div>
            </div> */}
          </div>
        </div>

        {/* Aviso para asociados */}
        <div className="oclem-special-notice">
          <p>
            Precios especiales para asociados, contáctanos para más información.
          </p>
        </div>
      </div>

      {/* Botón para volver arriba */}
      <div className="oclem-scroll-top" onClick={scrollToTop}>
        <ChevronUp size={24} className="oclem-scroll-icon" />
      </div>

      {/* Barra de copyright */}
      <div className="oclem-copyright">
        <p>Oclem Consultoría © {currentYear}. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;
